import ReleasedToDetailsItem from './ReleasedToDetailsItem';



export default ReleasedToDetailsItem;
